var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-grid gap-2"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-bs-toggle":"modal","data-bs-target":"#nayConfirmationModal"},on:{"click":_vm.handleClick}},[_c('span',{staticClass:"nayText"},[_vm._v("Nay")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }